module.exports = function() {
  return new Worker(__webpack_public_path__ + "d77ad731a2ce146b0a77.worker.js");
};